<div class="custom-pagination" [class.align-left]="alignment === 'left'" [class.align-right]="alignment === 'right'">
  <div class="pagination-container">
    <!-- Items per page display -->
    <div class="items-per-page">
      <span class="page-size-number">{{ totalPages }}</span>
      <span class="page-size-label">{{'page' | translate}}</span>
    </div>

    <!-- Navigation controls -->
    <div class="navigation-controls">
      <button class="nav-button" [disabled]="isFirstPage" (click)="goToFirstPage()" aria-label="First page">
        «
      </button>
      <button class="nav-button" [disabled]="isFirstPage" (click)="goToPreviousPage()" aria-label="Previous page">
        ‹
      </button>
      <div class="current-page">
        <input mat-input type="text" [value]="currentPage"
        (change)="goToCertainPage($event.target.value)"
         (keypress)="allowOnlyNumbers($event)"
        id="currentPage" aria-label="'currentPage' | translate" />
      </div>
      <button class="nav-button" [disabled]="isLastPage" (click)="goToNextPage()" aria-label="Next page">
        ›
      </button>
      <button class="nav-button" [disabled]="isLastPage" (click)="goToLastPage()" aria-label="Last page">
        »
      </button>
    </div>

    <!-- Record range and total -->
    <div class="record-info">
      <div class="record-range">{{ recordRange }}</div>
      <div class="total-records">
        <span class="total-number">{{ formattedTotalRecords }}</span>
        <span class="total-label">{{'records' | translate}}</span>
      </div>
    </div>
  </div>
</div>
